import { Pagination, paginationToParams } from '../Pagination';

export interface N11OrderFilter {
  pagination: Pagination;
}

export const getDefaultN11OrderFilter = (): N11OrderFilter => ({
  pagination: {
    page: 0,
    pageSize: 10,
  },
});

export const n11OrderFilterToQueryParams = (filter: N11OrderFilter) => ({
  ...paginationToParams(filter.pagination),
});
